import { PackageToRemediateType } from "~/components/Remediation/types";

export const PACKAGES_TO_REMEDIATE = {
  ALL: "all-packages",
  INDIVIDUAL: "individual-packages",
} as const;

// Create a type guard function
export function isPackageToRemediate(
  value: string,
): value is PackageToRemediateType {
  return Object.values(PACKAGES_TO_REMEDIATE).includes(
    value as PackageToRemediateType,
  );
}
